var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.tools.length > 0)?_c('div',{staticClass:"b-project-tools"},[_c('heading',{attrs:{"suptitle":_vm.$t('misc.tools')}}),_c('list',{staticClass:"b-project-tools__list",attrs:{"items":_vm.tools,"border":true}})],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }